import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseUnits } from "viem";
import BusdAbi from "../../utils/busdAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const useApproveTpl = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const tokenAddress = Environment.busd;
  const spenderAddress = Environment.presaleContract;

  const approveTpl = useCallback(
    async (amount) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      /* USDT uses 6 decimals ("mwei" in web3.js) */
      const nd = parseUnits(amount.toString(), 6);

      try {
        const hash = await writeContractAsync({
          address: tokenAddress,
          abi: BusdAbi,
          functionName: "approve",
          args: [spenderAddress, nd],
        });

        console.log("Approval tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("Approval confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("Approval failed:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync, tokenAddress, spenderAddress]
  );

  return { approveTpl };
};

export default useApproveTpl;
